var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7676 9.76581C18.5372 9.72401 18.6781 9.60486 18.7676 9.76581V9.76581Z",
    fill: "#B3D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1266 9.76332C20.2157 9.60321 20.3566 9.72193 20.1266 9.76332V9.76332Z",
    fill: "#B3D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6229 3.20077C29.957 -3.90189 21.8636 2.25974 19.6069 7.7433C17.9857 3.27895 10.3777 -2.76019 6.13238 1.95248C4.01329 4.30484 4.1249 7.93267 6.37443 10.1379C9.48931 13.1909 15.8311 11.4526 19.4406 10.7578C19.474 10.7173 19.5037 10.6751 19.5334 10.6324C24.6449 13.6148 37.7908 11.3155 33.6229 3.20077ZM7.94378 5.8512C7.9049 4.72832 9.24851 3.22042 10.7292 3.08581C13.2087 3.04401 17.5865 7.63836 18.7675 9.76582C16.1906 9.30053 8.07338 10.2207 7.94378 5.8512ZM20.1266 9.76331C21.3088 7.63669 25.6829 3.04401 28.1619 3.08581C29.6426 3.22042 30.9867 4.72832 30.9474 5.8512C30.8174 10.2202 22.703 9.29928 20.1266 9.76331Z",
    fill: "#B3D5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8786 13.2448C38.8786 14.9463 37.5994 16.3551 35.9523 16.5641C35.8143 16.5809 35.6763 16.5892 35.5342 16.5892H3.3444C3.20226 16.5892 3.0643 16.5809 2.92635 16.5641C1.27923 16.3551 0 14.9463 0 13.2448C0 11.4012 1.5008 9.90042 3.3444 9.90042H35.5342C37.3778 9.90042 38.8786 11.4012 38.8786 13.2448Z",
    fill: "#5D89EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9522 16.5641V24.5322H22.7837V16.5892H35.5342C35.6763 16.5892 35.8143 16.5809 35.9522 16.5641Z",
    fill: "#B3D5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9522 31.2209V36.6556C35.9522 39.3018 33.7658 40 32.6078 40H22.7836V31.2209H35.9522Z",
    fill: "#B3D5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0948 31.2209V40H6.27066C3.62441 40 2.92627 37.8136 2.92627 36.6556V31.2209H16.0948Z",
    fill: "#B3D5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0949 16.5892V24.5322H2.92633V16.5641C3.06429 16.5809 3.20224 16.5892 3.34438 16.5892H16.0949Z",
    fill: "#B3D5FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9522 24.5321V31.2209H22.7836V40H16.0948V31.2209H2.92627V24.5321H16.0948V16.5892H22.7836V24.5321H35.9522Z",
    fill: "#B3D5FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9522 24.5322V27.4213L18.3903 27.6956V40H16.0949V27.4213H2.92633V24.5322H16.0949V16.5892H18.3903V24.8065L35.9522 24.5322Z",
    fill: "#5D89EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftSvg);
export default __webpack_public_path__ + "static/media/Gift-SVG.5e2254f4.svg";
export { ForwardRef as ReactComponent };